import { render } from "./App.vue?vue&type=template&id=05dc156d&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=05dc156d&lang=css"
import "./App.vue?vue&type=style&index=1&id=05dc156d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-05dc156d"

export default script